import { setBypassBlockNavigation } from '../reducers/blockNavigation.js';

export const bypassNavigationBlock = (data) => {
    return (dispatch) => {
        dispatch(setBypassBlockNavigation(data));
    };
};
